export const isDealer = (organization: any) =>
  organization?.account_type === 'dealer';
export const isMonarchDigital = (organization: any) =>
  organization?.account_type === 'monarch_digital';
